import { Component } from '@angular/core';

@Component({
  selector: 'mprd-wifi-credentials-skeleton',
  templateUrl: './wifi-credentials-skeleton.component.html',
})
export class WifiCredentialsSkeletonComponent {}
